import { useEffect, useState } from "react";

export const useSize = ({ measureParent = true }: { measureParent?: boolean } = {}) => {
  const [ref, setRef] = useState<Element | null>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if ((measureParent && ref?.parentElement) || ref) {
      const observer = new ResizeObserver((entries) => {
        if (entries.length) {
          setSize({ width: entries[0].contentRect.width, height: entries[0].contentRect.height });
        }
      });
      observer.observe(measureParent && ref?.parentElement ? ref.parentElement : ref);
      return () => {
        observer.disconnect();
      };
    }
  }, [ref, measureParent]);

  return { setRef, size };
};
